import { useState } from "react";
import { SITE } from "../data/site";
import { LogoMark, IconMenu, IconClose } from "./Icons";

const LINKS = [
  { href: "/", label: "Beranda", testid: "nav-link-home" },
  { href: "/menu/", label: "Menu", testid: "nav-link-menu" },
  { href: "/tentang/", label: "Tentang", testid: "nav-link-tentang" },
  { href: "/lokasi/", label: "Lokasi", testid: "nav-link-lokasi" },
  { href: "/faq/", label: "FAQ", testid: "nav-link-faq" },
];

export const Header = ({ currentPath = "/" }) => {
  const [open, setOpen] = useState(false);
  const isActive = (href) =>
    href === "/" ? currentPath === "/" : currentPath.startsWith(href);

  return (
    <header className="fixed inset-x-0 top-0 z-40 border-b border-white/10 bg-coal/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <a
          href="/"
          data-testid="nav-logo-link"
          aria-label="Burger Blenger — kembali ke beranda"
          className="flex items-center gap-2.5"
        >
          <LogoMark className="h-9 w-9" />
          <span className="pt-1 font-display text-2xl leading-none tracking-wide text-cream">
            BURGER<span className="text-blood">BLENGER</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Navigasi utama">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              aria-current={isActive(l.href) ? "page" : undefined}
              className={`font-mono text-xs uppercase tracking-[0.18em] transition-colors ${
                isActive(l.href) ? "text-cheddar" : "text-sand hover:text-cream"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-instagram-cta"
            className="btn-primary"
          >
            Pesan via IG
          </a>
        </nav>

        <button
          type="button"
          className="flex h-11 w-11 items-center justify-center border border-white/15 text-cream md:hidden"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? "Tutup menu navigasi" : "Buka menu navigasi"}
          data-testid="mobile-nav-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <IconClose className="h-6 w-6" /> : <IconMenu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          id="mobile-nav"
          aria-label="Navigasi seluler"
          className="border-t border-white/10 bg-coal px-5 pb-6 pt-3 md:hidden"
        >
          <ul className="flex flex-col">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`mobile-${l.testid}`}
                  aria-current={isActive(l.href) ? "page" : undefined}
                  className={`block border-b border-white/5 py-4 font-display text-2xl tracking-wide ${
                    isActive(l.href) ? "text-cheddar" : "text-cream"
                  }`}
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="pt-5">
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-nav-instagram-cta"
                className="btn-primary w-full justify-center"
              >
                Pesan via Instagram
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};
